import { BottomSheet } from '../../../shared/views/baseLayoutViews';
import { FormTableOfContentsSectionStats } from './models';

export const FormTableOfContents = BottomSheet.extend({
    collection: null, // MobileFormStructure
    title: 'Table of Contents',
    current_section_id: null,
    on_click_section: function () {},

    initialize: function () {
        FormTableOfContents.__super__.initialize.apply(this, arguments);

        if (!this.collection) {
            throw new Error('Programmer Error: FormTableOfContents requires a collection');
        }
    },

    onRender: function () {
        var this_ = this;
        // we must build our list of sections via collection.each() instead of collection.where()
        // so the proper order is maintained.

        var visible_section_fields = this.collection.filter(function (model) {
            return model.get('type') === 'section' && !model.is_currently_hidden;
        });

        var sorted_section_fields = _.sortBy(visible_section_fields, function (field) {
            return this_.collection.metadata.get('order').indexOf(field.id.toString());
        });

        // Convert our form structure into a FormTableOfContentsSectionStats
        // that we can send to our r_bottom_sheet_body region
        var section_stats = new FormTableOfContentsSectionStats(
            _.map(sorted_section_fields, function (field) {
                return field.get_stats();
            })
        );

        this.r_bottom_sheet_body.show(
            new FormTableOfContentsList({
                collection: section_stats,
                current_section_id: this.current_section_id,
                on_click_section: this.on_click_section
            })
        );
    }
});

export const FormTableOfContentsListItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_form_table_of_contents_list_item',
    model: null, // FormTableOfContentsSectionStat
    tagName: 'li',

    is_active_section: false,
    on_click_section: function () {},

    events: {
        'click .navlink': 'click_section'
    },

    templateHelpers: function () {
        return {
            is_active_section: this.is_active_section
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onRender: function () {
        var left_pad = 16;
        this.$el.css('padding-left', this.model.get('nesting_level') * left_pad);
    },

    click_section: function (event) {
        this.on_click_section(this.model.get('section'));
        return false;
    }
});

export const FormTableOfContentsList = Backbone.Marionette.CollectionView.extend({
    itemView: FormTableOfContentsListItem,
    tagName: 'ul',
    className: 'pagelist section_stats_list',

    collection: null, // FormTableOfContentsSectionStats
    current_section_id: null, // The ID of the current section, which we should highlight
    on_click_section: function () {}, // Function to be called when user selects a section

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    getItemView: function (model) {
        var section_id = model.get('section') ? model.get('section').id : null;
        return this.itemView.extend({
            is_active_section: !!this.current_section_id && this.current_section_id === section_id,
            on_click_section: this.on_click_section
        });
    }
});
